{
  "main": {
    "title": "Impostazioni account"
  },
  "geslo": {
    "title": "Modifica password utente",
    "description": "Aggiorna la tua password per maggiore sicurezza",
    "labels": {
      "staroGeslo": "Vecchia password",
      "novoGeslo": "Nuova password",
      "potrditevGesla": "Conferma nuova password"
    },
    "buttons": {
      "ponastaviGeslo": "Reimposta password"
    }
  },
  "podatki": {
    "title": "Dati del pilota",
    "description": "Modifica dei dati (Indirizzo, telefono, e-mail)"
  },
  "podpis": {
    "title": "Firma digitale",
    "description": "Aggiungi la tua firma per le fatture"
  },
  "auth": {
    "title": "Autenticazione 2FA",
    "description": "Impostazioni di autenticazione 2FA"
  },
  "language": {
    "title": "Lingua",
    "description": "Impostazioni della lingua dell'interfaccia utente"
  },
  "buttons": {
    "zakljuci": "Termina modifica"
  },
  "bracun": {
    "title": "Cancellazione dell'account",
    "description": "Cancellazione/disattivazione dell'account"
  },
  "obvestila": {
    "podpisDodan": "Firma aggiunta alla fattura. La firma sarà visibile dopo aver effettuato nuovamente l'accesso",
    "gesloSpremenjeno": "Password modificata con successo. Verrai disconnesso automaticamente tra pochi secondi...",
    "gesloNiUjema": "Le password non corrispondono",
    "napacnoGeslo": "La vecchia password inserita non è corretta!",
    "napakaPosodabljanja": "Errore nell'aggiornamento dei dati",
    "napakaBranja": "Errore nella lettura dei dati"
  }
}